'use memo';

import { AgxIconCircularGreenTick } from '@urbanx/agx-ui-components';
import { CampaignDetailModel } from '@urbanx/agx.campaigns.client';
import { AgxSpacer, AgxTypography, Icon_Clock } from '@urbanx/agx.ui-components2';
import React from 'react';

interface SolicitorContractDetailsProps {
  campaign: CampaignDetailModel;
}

export const SolicitorContractDetails: React.FC<SolicitorContractDetailsProps> = ({ campaign }) => {
  return (
    <AgxSpacer
      padding={{ top: 'spacing-xl', bottom: 'spacing-xl' }}
      gap="spacing-xl"
      contentAlignment="center"
    >
      {!campaign.blankContractIsLive && (
        <>
          <Icon_Clock color="var(--fg-disabled, #DFDFDF)" width={44} height={44} />
          <AgxTypography id="await-contract-from-solicitor" type="body" size="medium">
            Awaiting Contract from Solicitor
          </AgxTypography>
        </>
      )}
      {campaign.blankContractIsLive && campaign.blankSalesContractStatus && (
        <>
          <AgxIconCircularGreenTick width={44} height={45} />
          <AgxTypography
            id={`${campaign.blankSalesContractStatus}-contract-from-solicitor`}
            type="body"
            size="medium"
          >
            {campaign.blankSalesContractStatus} Contract is ready
          </AgxTypography>
        </>
      )}
    </AgxSpacer>
  );
};
